<template>
  <v-container fluid class="px-0">
    <div class="dataContainer" @keydown.enter.prevent="searchData()">
      <v-row>
        <v-col cols="12" md="4">
          <el-date-picker
            label="Akto sukūrimo data nuo"
            tooltip="Archyvo naikinimas. Akto naikinimas. Akto sukūrimo data nuo"
            v-model="formData.nak_sukurimo_data_nuo"
          />
        </v-col>
        <v-col cols="12" md="4">
          <el-date-picker
            label="Akto sukūrimo data iki"
            tooltip="Archyvo naikinimas. Akto naikinimas. Akto sukūrimo data iki"
            v-model="formData.nak_sukurimo_data_iki"
          />
        </v-col>
        <v-col cols="12" md="4"></v-col>

        <v-col cols="12" md="4">
          <el-date-picker
            label="DVS data nuo"
            tooltip="Archyvo naikinimas. Akto naikinimas. DVS data nuo"
            v-model="formData.nak_dvs_data_nuo"
          />
        </v-col>
        <v-col cols="12" md="4">
          <el-date-picker
            label="DVS data iki"
            tooltip="Archyvo naikinimas. Akto naikinimas. DVS data iki"
            v-model="formData.nak_dvs_data_iki"
          />
        </v-col>
        <v-col cols="12" md="4">
          <el-text-field
            label="DVS numeris"
            tooltip="Archyvo naikinimas. Akto naikinimas. DVS numeris"
            v-model="formData.nak_dvs_numeris"
          />
        </v-col>
        <v-col cols="12" md="4">
          <el-date-picker
            label="Sunaikinimo data nuo"
            tooltip="Archyvo naikinimas. Akto naikinimas. Sunaikinimo data nuo"
            v-model="formData.nak_naikinimo_data_nuo"
          />
        </v-col>
        <v-col cols="12" md="4">
          <el-date-picker
            label="Sunaikinimo data iki"
            tooltip="Archyvo naikinimas. Akto naikinimas. Sunaikinimo data iki"
            v-model="formData.nak_naikinimo_data_iki"
          />
        </v-col>
        <v-col cols="12" md="6">
          <el-text-field
            label="Aktą sugeneravęs asmuo"
            tooltip="Archyvo naikinimas. Akto naikinimas. Aktą sugeneravęs asmuo"
            v-model="formData.suformavo"
          />
        </v-col>
        <v-col cols="12" md="6">
          <el-text-field
            label="Duomenis naikinęs asmuo"
            tooltip="Archyvo naikinimas. Akto naikinimas. Duomenis naikinęs asmuo"
            v-model="formData.naikino"
          />
        </v-col>

        <v-col cols="12">
          <el-button
            primary
            :loading="loading"
            @click.native.stop="searchData()"
          >
            Ieškoti
          </el-button>
          <el-button :loading="loading" @click.native="clearData()">
            Išvalyti
          </el-button>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NaikinimasAktasSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    formData: {},
    isSearching: false,
  }),
  computed: {
    ...mapGetters(['searchParams']),
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.searchData()
    },
    searchData() {
      this.$validator.validateAll().then(res => {
        this.isSearching = true
        this.$emit('search', this.formData)
      })
    },
    clearData() {
      this.isSearching = false
      this.formData = {}
      // this.$emit('cancel')
    },
  },
}
</script>
<style lang="scss" scoped>
.dataContainer {
  max-width: 1000px;
}
</style>
